import { gql } from '@apollo/client';

export const CERTIFICATE_OVERRIDE = gql`
    query CertificateTemplate( $certificateTemplateId: UUID! ) {
        certificateTemplate( certificateTemplateID: $certificateTemplateId ) {
            node {
                id
                name
                certificateTemplateOverrides {
                    id
                    name
                    description
                    certificateTemplateId
                    segments
                    templateKey
                    certificateTemplateOverrideUrl
                    weight
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;
 